var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-picker',{attrs:{"title":_vm.text,"icon":'/static/img/sort-light.svg',"children":_vm.options,"is-active":_vm.checkIsActive,"close-on-click":false},on:{"click-child":_vm.handleSelect}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57f9ac5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/parts/search-sorter.vue
// module id = null
// module chunks = 